
import {
  Component,
  Vue,
  Inject,
  Prop,
  Watch,
  Ref
} from "vue-property-decorator";

import api from "@/api";
import { CreateOrEditCardDto } from "@/api/appService";
import { ElForm } from "element-ui/types/form";

@Component
export default class EditCard extends Vue {
  @Ref() readonly dataForm!: ElForm;
  @Watch("show")
  async onShowChange(value: boolean) {
    if (value) {
      await api.card.getForEdit({ id: this.form!.id }).then(res => {
        this.form = res.data;
        if (!this.form!.id) {
          this.form!.status = 1;
        }
      });
    } else {
      this.form = { ...this.defaultData };
    }
    this.$nextTick(() => {
      this.dataForm.clearValidate();
    });
  }

  pickerOptions = {};

  defaultData: CreateOrEditCardDto = {
    title: undefined,
    titleImageUrl: undefined,
    desc: undefined,
    ageDesc: undefined,
    startTime: undefined,
    endTime: undefined,
    status: 1,
    inventoryNum: undefined,
    memberInfo: undefined,
    buyInfo: undefined,
    cardsTypeInfo: undefined,
    organizationUnitId: undefined,
    id: 0
  };

  show = false;
  form: CreateOrEditCardDto | undefined = { ...this.defaultData };

  get cardDialogTitle() {
    if (this.form!.id) {
      return "编辑";
    } else {
      return "新建";
    }
  }

  async save() {
    console.log(this.form);
    (this.$refs.dataForm as any).validate(async (valid: boolean) => {
      if (valid) {
        if (this.form!.id) {
          await api.card.update({ body: this.form });
        } else {
          await api.card.create({ body: this.form });
        }
        this.show = false;
        this.$message.success("更新成功");
        this.$emit("onSave");
      }
    });
  }

  // 图片上传前判断
  async beforeAvatarUpload(file: any) {
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      this.$message.error("上传的图片大小不能超过 2MB!");
    }
    return isLt2M;
  }

  async handleAvatarSuccess(res: any, file: any) {
    console.log(res);
    if (res.success) {
      this.form!.titleImageUrl = res.result;
    }
  }

  cancel() {
    this.show = false;
  }

  roleRule = {
    name: [
      {
        required: true,
        message: "必填",
        trigger: "blur"
      }
    ]
  };
}
